import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row container-fluid mt-2 d-flex w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Information du client")
], -1)
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "tx-11 fw-bolder mb-0 text-uppercase text-primary" }, "Nom du client:", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_11 = { class: "mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "tx-11 fw-bolder mb-0 text-uppercase text-primary" }, "Adresse du client:", -1)
const _hoisted_13 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "tx-11 fw-bolder mb-0 text-uppercase text-primary" }, "Numéro de téléphone:", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        (_ctx.order?.customer)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.order?.customer?.firstName) + " " + _toDisplayString(_ctx.order?.customer?.lastName), 1))
          : _createCommentVNode("", true),
        (_ctx.order?.customerstore)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.order?.customerstore?.firstName) + " " + _toDisplayString(_ctx.order?.customerstore?.lastName), 1))
          : _createCommentVNode("", true),
        (_ctx.order?.borne_cust_name)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.order?.borne_cust_name), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.order?.customerstore?.address)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("p", null, _toDisplayString(_ctx.order?.customerstore?.address), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.order?.customer?.phone || _ctx.order?.customerstore?.phone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            (_ctx.order?.customer)
              ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.order?.customer?.phone), 1))
              : _createCommentVNode("", true),
            (_ctx.order?.customerstore)
              ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.order?.customerstore?.phone), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}